import { Badge, Box, Flex, Icon, Radio, Text } from '@chakra-ui/react';
import { BsStar } from 'react-icons/bs';

export interface ContractTypeOption {
  value: string;
  label: string;
  description: string;
  durationValue: number;
  durationValueUnit: 'day' | 'week' | 'month' | 'year';
  orderCycleDays: number;
  uniqueRestriction: boolean;
  recommended?: boolean;
}

interface ContractTypeRadioProps {
  option: ContractTypeOption;
  isChecked: boolean;
  onChange: () => void;
}

const ContractTypeRadio: React.FC<ContractTypeRadioProps> = ({
  option,
  isChecked,
  onChange,
}) => {
  return (
    <Box
      as="button"
      type="button"
      w="100%"
      textAlign="left"
      border="none"
      bg={isChecked ? 'yooga.50' : 'white'}
      borderRadius="md"
      transition="all 0.2s"
      px={0}
      py={0}
      _focus={{ boxShadow: 'outline' }}
      onClick={onChange}
    >
      <Flex
        px={8}
        py={4}
        direction="column"
        align="flex-start"
        gap={2}
        w="100%"
      >
        <Flex align="center">
          <Radio
            isChecked={isChecked}
            value={option.value}
            colorScheme="yooga"
            pointerEvents="none"
            mr={2}
          >
            <Text fontWeight="medium" fontSize="1rem">
              {option.label}
            </Text>
          </Radio>
          {option.recommended && (
            <Badge
              ml={3}
              colorScheme="yooga"
              variant="subtle"
              fontSize="0.75rem"
              py={1}
              px={2}
              textTransform={'capitalize'}
              fontWeight={'medium'}
              borderRadius={'full'}
              display={'flex'}
              alignItems={'center'}
              gap={1}
            >
              <Icon as={BsStar} boxSize="1.2em" /> Recomendado
            </Badge>
          )}
        </Flex>
        {option.description && (
          <Text color="gray.500" fontSize="0.85rem">
            {option.description}
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default ContractTypeRadio;
